module.exports = __webpack_public_path__ + "img/role5.64eb0c5b.png";